import * as React from 'react';
export const southstateSvg = React.forwardRef(function southstateSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#002D72',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.286 13.493c.954-.714 1.994-1.505 3.043-2.325.658-.515.925-1.334-.067-1.992-.33-.218-1.118-.777-2.027-1.423-1.353-.96-2.976-2.11-3.763-2.618-.782-.505-2.804.429-2.213 2.45.4 1.372 2.337 3.573 5.027 5.908Zm-6.563 5.014c-.954.724-1.993 1.515-3.043 2.325-.658.515-.925 1.334.067 1.992.33.218 1.118.777 2.028 1.423 1.353.96 2.975 2.11 3.762 2.618.792.505 2.795-.429 2.213-2.45-.4-1.372-2.337-3.573-5.027-5.908Zm2.099-7.101 5.914 6.128c1.46 1.516 3.72 4.032.963 5.967l-.386.271c-1.654 1.165-1.957 1.379-1.912.872.076-.981-.506-2.249-2.223-4.07 0 0-5.704-5.908-5.914-6.128-1.46-1.515-3.72-4.031-.963-5.966l.386-.272c1.654-1.164 1.957-1.378 1.912-.871-.076.981.506 2.249 2.223 4.07Z',
      fill: '#FCBC3B',
    }),
  );
});
southstateSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var southstate = {
  category: 'brand',
  colorable: false,
  name: 'southstate',
  svg: southstateSvg,
};
